<template>
  <div v-if="tasks.data" class="gantt-wrapper">
    <div class="legend">
      <span class="underway"></span>进行中 <span class="finished"></span>已完成
    </div>
    <div
      :ref="`gantt${activeIndex}`"
      class="gantt-container"
      :style="{ height: tabheight + 'px' }"
    ></div>
  </div>
</template>

<script>
import gantt from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";

export default {
  name: "GanttMobile",
  props: ["ganttData", "index"],
  data() {
    return {
      onTaskDblClick: null,
      tasks: { data: [] },
      tabheight: 0,
      rowHeight: 32,
      scaleHeight: 50,
      activeIndex: 0,
      ganttInstances: {},
      lastTouch: null,
      minSlideDistance: 10,
      startX: 0,
      startY: 0,
      startTime: 0,
      isDragging: false,
      timer: null,
    };
  },
  watch: {
    ganttData: {
      handler(val) {
        this.tasks.data = this.flattenArray(val);
        this.$nextTick(function () {
          this.init();
        });
      },
      deep: true,
      immediate: true,
    },
    index: {
      handler(val) {
        this.activeIndex = val;
        this.$nextTick(function () {
          this.init();
        });
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.addMobileTouchControl();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    flattenArray(arr) {
      return arr.flatMap(function (item) {
        const parentItem = {
          ...item,
          id: item.incubateId + item.projectNode,
          text: item.projectNode,
          open: false,
          start_date: item.startDay,
          end_date: item.endDay ? item.endDay + " 23:59:59" : new Date(),
          status: item.status,
        };

        // if (
        //   !item.progressResponseList ||
        //   item.progressResponseList.length === 0
        // ) {
        //   return [parentItem];
        // }

        // const childItems = item.progressResponseList.map(function (subItem) {
        //   return {
        //     ...subItem,
        //     text: subItem.nodeProgress,
        //     id: subItem.incubateId + "-" + subItem.id,
        //     parent: subItem.incubateId + item.projectNode,
        //     open: true,
        //     start_date: subItem.nodeStartDay,
        //     end_date: subItem.nodeEndDay
        //       ? subItem.nodeEndDay + " 23:59:59"
        //       : new Date(),
        //     status: item.status
        //   };
        // });

        return [parentItem];
      });
    },
    init() {
      const localGantt = this.ganttInstances[this.activeIndex] || gantt;
      this.ganttInstances[this.activeIndex] = localGantt;
      localGantt.i18n.setLocale("cn");
      localGantt.config.date_format = "%d-%m-%Y";
      localGantt.config.readonly = true;
      // localGantt.config.show_grid = true;
      localGantt.config.autosize = true;
      localGantt.config.scale_height = this.scaleHeight;
      localGantt.config.row_height = this.rowHeight;
      localGantt.templates.date_grid = function (date, task) {
        if (!date) {
          return "";
        }
        return localGantt.templates.grid_date_format(date);
      };
      localGantt.config.bar_height = 26;
      localGantt.config.xml_date = "%Y-%m-%d %H:%i";
      localGantt.config.fit_tasks = false;
      // 定义时间格式
      localGantt.config.scales = [
        { unit: "month", step: 0, date: " %Y 年  %F" },
        { unit: "day", step: 0, date: "%d" },
      ];
      localGantt.config.min_column_width = 30; // 把最小列宽设置为 30s
      localGantt.config.columns = [
        {
          name: "text",
          label: "项目",
          tree: true,
          width: "130",
          template: function (task) {
            return task.parent
              ? '<span title="' + task.text + '">' + task.text + "</span>"
              : '<div style="font-weight: 700"><span title="' +
                  task.text +
                  '">' +
                  task.text +
                  "</span></div>";
          },
          align: "center",
        },
        {
          name: "superintendent",
          label: "负责人",
          width: "60",
          align: "center",
        },
      ];
      // // // 设置最小日期为4月1号
      // localGantt.config.min_date = new Date("2024-04-01");
      // // 设置最大日期为4月30号
      // localGantt.config.max_date = new Date("2024-04-30");
      // localGantt.config.show_tasks_outside_timescale = false;
      localGantt.templates.task_class = function (start, end, item) {
        switch (item.status) {
          case "已完成":
            return "gantt_success";
          case "进行中":
            return "gantt_primary";
          case "未开始":
            return "gantt_begined";
          default:
            return "gantt_begined";
        }
      };

      if (this.onTaskDblClick) {
        localGantt.detachEvent(this.onTaskDblClick);
      }

      this.onTaskDblClick = localGantt.attachEvent(
        "onTaskDblClick",
        function (id) {
          // this.$emit("rowDbClick", id);
          return true;
        }
      );
      localGantt.config.date_format = "%Y-%m-%d";
      localGantt.clearAll();
      // localGantt.config.start_date = new Date(2024, "02", "31");
      // localGantt.config.end_date = new Date(2019, "03", "09");
      localGantt.config.show_tasks_outside_timescale = true;
      localGantt.init(this.$refs["gantt" + this.activeIndex]);
      // localGantt.config.str_to_date = new Date("01-04-2024");

      localGantt.parse(this.tasks);
      localGantt.render();
      // const startDate = localGantt.date.str_to_date("%Y-%m-%d")("2025-04-01");
      // const endDate = localGantt.date.str_to_date("%Y-%m-%d")("2025-06-01");
      // localGantt.config.start_date = startDate;
      // localGantt.config.end_date = endDate;
      // 获取当前日期
      let currentDate = new Date();

      // 加上两天
      let newDate = new Date(currentDate.getTime() + 2 * 24 * 60 * 60 * 1000);
      localGantt.showDate(newDate);

      this.updateGanttHeight();
    },
    updateGanttHeight() {
      const taskCount = this.tasks.data.length;
      let totalHeight = taskCount * this.rowHeight + this.scaleHeight + 20;

      const ref = this.$refs["gantt" + this.activeIndex];
      const parent = ref ? ref.parentElement : null;

      if (parent && totalHeight > parent.clientHeight) {
        totalHeight = parent.clientHeight;
      }

      this.tabheight = totalHeight;
    },
    handleResize() {
      this.updateGanttHeight();
    },
    isVerticalScroll(e) {
      if (e.touches.length < 2) {
        const touch = e.touches[0];
        if (!this.lastTouch) {
          this.lastTouch = touch;
          return true;
        }
        const dx = Math.abs(touch.clientX - this.lastTouch.clientX);
        const dy = Math.abs(touch.clientY - this.lastTouch.clientY);
        this.lastTouch = touch;
        return dy >= dx;
      }
      return true;
    },
    addMobileTouchControl() {
      this.$nextTick(() => {
        const el = this.$refs[`gantt${this.activeIndex}`];
        if (!el) return;

        let startX = 0;
        let startY = 0;
        let startTime = 0;

        el.addEventListener(
          "touchstart",
          (e) => {
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            startTime = Date.now();
          },
          { passive: true }
        );

        el.addEventListener(
          "touchmove",
          (e) => {
            const touch = e.touches[0];
            const deltaX = Math.abs(touch.clientX - startX);
            const deltaY = Math.abs(touch.clientY - startY);
            const deltaTime = Date.now() - startTime;

            if (
              deltaX < this.minSlideDistance &&
              deltaY < this.minSlideDistance
            ) {
              return;
            }

            const grid = el.querySelector(".gantt_grid");
            if (grid) {
              const gridRect = grid.getBoundingClientRect();
              const touchX = touch.clientX;
              const isInFixedColumns =
                touchX >= gridRect.left && touchX <= gridRect.left + 170;

              if (deltaX > deltaY && isInFixedColumns && e.cancelable) {
                e.preventDefault();
              }
            }

            if (deltaY > deltaX && e.cancelable) {
              e.stopPropagation();
            }
          },
          { passive: false }
        );

        el.addEventListener(
          "touchend",
          () => {
            // 重置状态
            startX = 0;
            startY = 0;
            startTime = 0;
          },
          { passive: true }
        );
      });
    },
  },
};
</script>

<style lang="less" scoped>
.gantt-wrapper {
  overflow: hidden;
}
.gantt-container {
  overflow-y: auto;
  overflow-x: auto;
  touch-action: pan-y pan-x;
}

.legend {
  padding: 0 0 10px 0;
}
.finished,
.underway {
  display: inline-block;
  width: 20px;
  height: 10px;
  margin-right: 6px;
}
.finished {
  background: #ff7e7e;
}
.underway {
  background: #70cc72;
}
</style>

<style lang="less">
.gantt_success {
  background: #ff7e7e;
}
.gantt_primary {
  background: #70cc72;
}
.gantt_begined {
  // background: #9a9a9a;
  background: #fff;
}
.gantt_tree_icon.gantt_blank {
  width: 0;
}
.gantt_cell {
  padding: 0 5px;
}
</style>
